export default {
  filter: {
    selectDepartment: 'Select department',
    selectedDepartments: 'Selected',
    more: 'More'
  },
  overview: {
    summary: 'Summary',
    fillingStatus: 'Filling status',
    publishedNum: 'Number of released staff',
    unpublishedNum: 'Number of not release staff',
    staffNum: 'Total number of staff',
    fillingRate: 'Filling rate',
    alignStatus: 'Align status',
    alignedNum: 'Number of Aligned staff',
    alignRate: 'Align rate',
    updateStatus: 'Update Status(This month)',
    updatedNum: 'Number of updated staff',
    updateRate: 'Update rate',
    reviewStatus: 'Review Status',
    reviewedNum: 'Number of reviewed staff',
    reviewRate: 'Review rate'
  },
  table: {
    title: 'statistical table',
    batchRemind: 'Batch remind',
    total: 'Total {count} items',
    filter: {
      name: 'Name',
      publishedStatus: 'Fill status',
      alignedStatus: 'Align status',
      updatedStatus: 'Update status',
      reviewedStatus: 'Review status',
      options: {
        published: 'Released',
        unpublished: 'Not release',
        aligned: 'Aligned',
        unaligned: 'Not align',
        updated: 'Updated',
        unupdated: 'Not update',
        unreviewed: 'Not review',
        reviewed: 'Reviewed'
      }
    },
    column: {
      name: 'Name',
      department: 'Department',
      fillingStatus: 'Fill status',
      publishedStatus: 'Release status',
      alignedStatus: 'Align status',
      alignedNum: 'Align number',
      updatedStatus: 'Update status (this month)',
      lastUpdatedTime: 'Last update time',
      reviewedStatus: 'Review status',
      lastReviewedTime: 'Last review time',
      lastRemindTime: 'Last remind time',
      action: 'Action'
    },
    remind: {
      name: 'Remind',
      label: 'Choose remind type',
      fill: 'Fill in',
      align: 'Align',
      update: 'Update',
      review: 'Review',
      successMessage: 'Remind successfully'
    },
    data: {
      未填写: 'No',
      已填写: 'Yes',
      未发布: 'No',
      已发布: 'Yes',
      未对齐: 'No',
      已对齐: 'Yes',
      未更新: 'No',
      已更新: 'Yes',
      未复盘: 'No',
      已复盘: 'Yes'
    }
  },
  statesChart: {
    title: 'States Analysis',
    顺利: 'Normal',
    拖延: 'Delayed',
    风险: 'Risky',
    放弃: 'Abandoned'
  },
  departmentsChart: {
    title: 'Department Analysis',
    填写率: 'Fill Rate',
    对齐率: 'Align Rate',
    更新率: 'Update Rate',
    复盘率: 'Review Rate'
  }
}
